import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IActivity, IActivityInitialState } from "./activitiesModal";
import {
  ActiveInactiveActivity,
  ActivityImageUpload,
  createActivity,
  deleteActivity,
  getAllActiveActivity,
  getAllActivity,
  getActivityByID,
  updateActivity,
} from "./services/activities.services";

const initialState: IActivityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ActivityID: null,
  ActivityList: [],
  ActivityDetail: {
    ID: null,
    PropertyID: null,
    Title: "",
    Description: "",
    SequenceNo: null,
    IsActive: 1,
  },
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearActivityDetails: (state) => {
      state.ActivityDetail = initialState.ActivityDetail;
    },
    setActivityID: (state, action) => {
      state.ActivityID = action.payload;
    },
    clearActivityID: (state) => {
      state.ActivityID = initialState.ActivityID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivity.fulfilled,
      (state, action: PayloadAction<IActivity[]>) => {
        state.loading = false;
        state.ActivityList = action.payload || [];
      },
    );
    builder.addCase(getAllActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActivityList = [];
    });
    builder.addCase(createActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createActivity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateActivity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteActivity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getActivityByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getActivityByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ActivityDetail = action.payload;
    });
    builder.addCase(getActivityByID.rejected, (state, action) => {
      state.loading = false;
      state.ActivityDetail = initialState.ActivityDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveActivity.fulfilled,
      (state, action: PayloadAction<IActivity[]>) => {
        state.loading = false;
        state.ActivityList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ActivityList = [];
    });
    builder.addCase(ActiveInactiveActivity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveActivity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveActivity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ActivityImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActivityImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActivityImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearActivityDetails, clearActivityID, setActivityID } =
  activitySlice.actions;
export default activitySlice.reducer;
